<template>
    <div>
        <!-- Titulo -->
        <div class="no-background mt-96">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-10 offset-lg-1 text-center text">
                        <h1 class="custom-h1 primary-color"><b>Detalhe do Protocolo </b></h1>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!resultado" class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">A carregar...</span>
          </div>
        </div>

        <div v-if="resultado" class="background primary-color mt-56">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-8 offset-lg-2">
                        <h1 class="custom-h2-title primary-color"> {{ resultado.subempresa !== null && resultado.subempresa !== '' && resultado.subempresa !== resultado.empresa ?
                            (resultado.empresa + ' - ' + resultado.subempresa) :
                            resultado.empresa }}</h1>
                    </div>

                    <div class="col-12 offset-lg-2 col-lg-4 mt-40">

                        <div class="location">
                            <img src="assets/images/orange_location.png" class="mr-1" />
                            <div class="location-text">
                                <p class="custom-p block sm primary-color">
                                    {{ resultado.morada }} <br/>
                                    {{ resultado.codigo_postal }} {{ resultado.localidade }}
                                </p>

                                <div class="btn-hide-mobile mt-16">
                                    <a class="text-decoration-none" target="_new" :href="'https://www.google.com/maps?saddr=' + userCurrentLocation + '&daddr=' + resultado.morada + ' ' + resultado.codigo_postal + ' ' + resultado.localidade">
                                        <span class="custom-h6 orange-direct">Ver direcções </span>
                                        <img src="assets/images/orange_arrow.png" />
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="col-12 col-lg-4 mt-40">

                        <div class="btn-hide">
                            <a class="text-decoration-none" target="_new" :href="'https://www.google.com/maps?saddr=' + userCurrentLocation + '&daddr=' + resultado.morada + ' ' + resultado.codigo_postal + ' ' + resultado.localidade">
                                <span class="custom-h6 orange-direct">Ver direcções </span>
                                <img src="assets/images/orange_arrow.png" />
                            </a>
                        </div>

                    </div>

                    <div class="col-12 col-lg-8 offset-lg-2 mt-32 telefone_div">

                        <p v-show="resultado.telefone !== null && resultado.telefone !== ''" class="custom-p block sm primary-color">
                            <img src="assets/images/orange_phone.png" class="mr-1" />
                            {{ resultado.telefone === null ? "&nbsp;" : resultado.telefone }}
                        </p>

                    </div>


                    <div class="col-12 col-lg-4 offset-lg-2">

                        <div class="btn-hide">
                            <p v-show="resultado.email !== null && resultado.email !== ''" class="custom-p block sm primary-color mt-32">
                                <img src="assets/images/orange_mail.png" class="mr-1" />
                                {{ resultado.email === null ? "&nbsp;" : resultado.email }}
                            </p>


                            <p v-show="resultado.site !== null && resultado.site !== ''" class="custom-p block sm primary-color mt-32">
                                <img src="assets/images/orange_link.png" class="mr-1" />
                                {{ resultado.site === null ? "&nbsp;" : resultado.site }}
                            </p>
                        </div>

                        <div class="btn-hide-mobile">
                            <p v-show="resultado.email !== null && resultado.email !== ''" class="a-link sm mt-32">
                                <img src="assets/images/orange_mail.png" class="mr-1" />
                                {{ resultado.email === null ? "&nbsp;" : resultado.email }}
                            </p>


                            <p v-show="resultado.site !== null && resultado.site !== ''"  class="a-link sm mt-32">
                                <img src="assets/images/orange_link.png" class="mr-1" />
                                {{ resultado.site === null ? "&nbsp;" : resultado.site }}
                            </p>
                        </div>

                    </div>

                    <div class="col-6 col-lg-2">

                        <div>
                            <h6 class="custom-h6 mt-32">
                                Categoria
                            </h6>
                        </div>

                        <div>
                            <p class="custom-p block sm primary-color mt-16">
                                {{ resultado.categoria }}
                            </p>
                        </div>

                    </div>

                    <div class="col-6 col-lg-2">

                        <div>
                            <h6 class="custom-h6 mt-32">
                                Serviço
                            </h6>
                        </div>

                        <div>
                            <p class="custom-p block sm primary-color mt-16">
                                {{ resultado.artigo }}
                            </p>
                        </div>

                    </div>


                </div>
            </div>
        </div>

        <div v-if="resultado" class="no-background mt-96">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-8 offset-lg-2">
                        <h3 class="custom-h3 primary-color">Condições</h3>

                        <h6 class="custom-h6 mt-32">
                            Desconto
                        </h6>

                        <p class="custom-h5 gray-color big mt-8">
                            {{ resultado.desconto }}
                        </p>

                        <div class="mt-32">
                            <p class="custom-p sm mt-8">{{ resultado.observacoes }}</p>
                            <hr class="special-line-no-margin mt-16" />
                        </div>


                        <div class="col-10 offset-1 col-lg-12 offset-lg-0">
                            <router-link class="custom-btn-secondary inline mt-40" :to="{name: 'SearchProtocolo'}">Voltar à Lista </router-link>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="mt-96"></div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    //import {scrollTop} from "@/store/dirpesquisador/actions";

    export default {
      name: 'Protocolo',
      components: {},
      data() {
          return {
              name: 'protocolo',
              loadComplete: false,
              resultado: null,
          };
      },
      created() {
          this.currentPageView = 1;
          this.setCurrentPage(this.name);
          this.loadProtocolo();
      },
      watch: {
            '$route.params.id': function(id) {
              if (this.$route.params.id !== undefined) {
                this.currentPageView = 1;
                this.loadComplete = false;
                this.resultado = '';
                this.loadProtocolo();
              }
            },
        },
        computed: {
            ...mapGetters('dirpesquisador',
                {
                  currentPage: 'getCurrentPage',
                  userCurrentLocation: 'getUserCurrentLocation',
                },
            ),
        },
        methods: {
            ...mapActions('dirpesquisador',
                {
                    setCurrentPage: 'setCurrentPage',
                    scrollFrameTop: 'scrollFrameTop',
                    loadProtocoloItem: 'loadProtocoloItem',
                },
            ),
            loadProtocolo() {
              const self = this;

              this.scrollFrameTop();
              this.loadProtocoloItem(
                  {
                    idExterno: this.$route.params.id,
                    currentPageView: this.currentPageView
                  },
              )
                  .then((response) => {
                    console.log(response);
                    console.log('Elapse time: -> ' + response.loggingTime);
                    self.loadComplete = true;
                    self.resultado = response;
                    self.scrollFrameTop();
                  })
                  .catch((error) => {
                    console.log('Error loading platform configs!');
                    self.loadComplete = true;
                  });
            },
        },
    };
</script>